module.exports = __webpack_public_path__ + "static/media/caret-square-right.49bc8fb2.svg";